import { get_token, get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import InactivityModal from "@/components/InactivityTracker/InactivityTracker.vue";
import Loader from "@/components/Loader/LoaderView";
import Swal from "sweetalert2";
import EventMediaGallery from "@/components/EventMediaGallery/event_media_gallery.vue";
import EventResource from "@/components/EventResource/event_resource.vue";
import EventSpeaker from '@/components/EventSpeaker/event_speaker.vue';
import EventSponsor from '@/components/EventSponsor/event_sponsor.vue';
import EventAgenda from '@/components/EventAgenda/event_agenda.vue';
import PromoCode from '@/components/PromoCode/event_promo_code.vue';
import EventSurvey from '@/components/EventSurvey/event_survey.vue';
import { client_domain } from "@/main.js";
import {
  check_description, format_date, format_time, get_user_id, get_event_media_files, get_event_resource_files,
  get_event_media_type,
  get_speaker_initials, get_sponsor_initials, get_sponsor_logo, scroll_sponsors, update_sponsor_scroll_controls,
  format_sponsor_url, is_promo_valid, new_format_date, show_toast, truncate_description, validate_ticket_date,
  calculate_subtotal, calculate_total, toggle_item, select_ticket,
  increment_ticket, decrement_ticket, select_promo, start_scanning, start_camera,
  scan_loop, stop_scanning, stop_camera_only, restart_scan, export_to_csv
} from "./event_helper";
import { fetchEvents_extras, apply_promo } from "./event_helper";
import {
  validate_ticket, validate_rsvp, submit_registration, cancel_rsvp, view_ticket_attendees,
  open_media_gallery, open_document_upload, get_icon_class, get_file_type_label, get_file_name,
  open_preview, download_document, update_parent_event_files, handle_parent_file_deletion,
  handle_pin_update, fetch_event, view_attendees, total_registrations, capacity_value,
  capacity_percent, capacity_text, event_date_line, ticket_breakdown, can_edit, show_ticket_rsvp_card, gallery_preview,
  has_more_gallery, materials_list, materials_preview, has_more_materials, materials_count,
  can_view_gallery, can_view_materials,
  description_text_length, has_long_description, plain_description, truncated_description,
  map_embed_url, selected_ticket, selected_tickets_total, add_rsvp
} from "./constant";
import * as survey_helper from "@/components/EventSurvey/event_survey_helper";
import { handle_manage_event_realtime } from "@/services/eventRealtimeHandlers";

export default {
  components: {
    HomeNavBar,
    InactivityModal,
    Loader,
    EventMediaGallery,
    EventResource,
    EventSpeaker,
    EventSponsor,
    EventAgenda,
    PromoCode,
    EventSurvey
  },
  data() {
    return ({
      is_loading: true, event: null, error_message: "", event_id: null, show_full_description: false,
      selected_event: {}, event_tickets: [], event_extras: [], selected_item_id: [],
      selected_ticket_id: null, promo_input: "", promo_message: "", promo_status: "",
      applied_promo: null, is_applying: false, scanning: false, show_camera: false,
      scan_result_box: false, scan_success: false, scan_error_message: "",
      scan_data: {}, current_event_id: null, video_stream: null, is_processing: false,
      business_name: "", is_first_time: false, chapter: "",
      chapters: [
        "Bedfordview",
        "Edevale",
        "Kempton Park",
        "Kyalami",
        "East Rand",
      ],
      selected_event_agenda: null, event_ticket_attendees: [], is_submitting: false, cbo_domain: false,
      workbook_domain: false, token_exists: false, show_sponsor_scroll_left: false,
      show_sponsor_scroll_right: false, user_details: {
        user_role: "",
        first_name: "",
        last_name: "",
        user_id: ""
      },
      expanded_creator_survey_id: null,
      show_event_survey_form: false, show_event_survey_answers: false, event_survey_answers: {},
      event_survey_errors: [], event_survey_first_error_question_id: null, event_survey_number_errors: {},
    });
  },
  computed: {
    event_survey() {
      return this.event?.survey?.[0]?.survey || null;
    },
    event_survey_questions() {
      return Array.isArray(this.event_survey?.survey_questions)
        ? this.event_survey.survey_questions
        : [];
    },
    event_survey_total_questions() {
      return this.event_survey_questions.length;
    },
    event_survey_answered_count() {
      return this.event_survey_questions.reduce((count, item) => {
        const questionId = item?.question?.id;
        if (!questionId) return count;
        const answer = Reflect.get(this.event_survey_answers, questionId);
        const hasAnswer = Array.isArray(answer)
          ? answer.length > 0
          : typeof answer === "string"
            ? answer.trim().length > 0
            : answer !== undefined && answer !== null && answer !== "";
        return hasAnswer ? count + 1 : count;
      }, 0);
    },
    event_survey_completion_percent() {
      if (!this.event_survey_total_questions) return 0;
      return Math.round((this.event_survey_answered_count / this.event_survey_total_questions) * 100);
    },
    event_surveys() {
      const list = Array.isArray(this.event?.survey) ? this.event.survey : [];
      return list.map((item) => item?.survey || item).filter(Boolean);
    },
    isEventEnded() {
    if (!this.event?.end_date) {
      return false;
    }
    const now = new Date();
    const endDate = new Date(this.event.end_date);
    return now > endDate;
  },
    total_registrations() {
      return total_registrations(this.event);
    },
    capacity_value() {
      return capacity_value(this.event);
    },
    capacity_percent() {
      return capacity_percent(this.total_registrations, this.capacity_value);
    },
    capacity_text() {
      return capacity_text(this.total_registrations, this.capacity_value);
    },
    event_date_line() {
      return event_date_line(this.event);
    },
    event_cover_image() {
      const event_file = this.event?.event_files?.find(
        (file) => file?.event_file_type?.name === "event_profile"
      );
      return event_file?.file?.file_url || this.event?.cover_image || "";
    },
    ticket_breakdown() {
      return ticket_breakdown(this.event);
    },
    can_edit() {
      const userId = this.get_user_id();
      return can_edit(this.token_exists, this.event, this.user_details, userId);
    },
    show_ticket_rsvp_card() {
      const userId = this.get_user_id();
      return show_ticket_rsvp_card(this.token_exists, this.event, this.user_details, userId);
    },
    gallery_access_allowed() {
      const userId = this.get_user_id();
      return can_view_gallery(this.token_exists, this.event, this.user_details, userId, this.event_ticket_attendees);
    },
    materials_access_allowed() {
      const userId = this.get_user_id();
      return can_view_materials(this.token_exists, this.event, this.user_details, userId, this.event_ticket_attendees);
    },
    gallery_preview() {
      return gallery_preview(this.event, this.gallery_access_allowed);
    },
    has_more_gallery() {
      return has_more_gallery(this.event, this.gallery_access_allowed);
    },
    materials_list() {
      return materials_list(this.event, this.materials_access_allowed);
    },
    materials_preview() {
      return materials_preview(this.materials_list);
    },
    has_more_materials() {
      return has_more_materials(this.materials_list);
    },
    materials_count() {
      return materials_count(this.materials_list);
    },
    description_text_length() {
      return description_text_length(this.event);
    },
    has_long_description() {
      return has_long_description(this.event);
    },
    plain_description() {
      return plain_description(this.event);
    },
    truncated_description() {
      return truncated_description(this.plain_description);
    },
    map_embed_url() {
      return map_embed_url(this.event);
    },
    selected_ticket() {
      return selected_ticket(this.event_tickets, this.selected_ticket_id);
    },
    selected_tickets_total() {
      return selected_tickets_total(this.event_tickets);
    },
  },
  methods: {
    ...survey_helper,
    open_event_survey_form() {
      this.show_event_survey_form = true;
      this.show_event_survey_answers = false;
      this.event_survey_errors = [];
      this.event_survey_first_error_question_id = null;
      this.event_survey_number_errors = {};
    },
    close_event_survey_form() {
      this.show_event_survey_form = false;
      this.event_survey_errors = [];
      this.event_survey_first_error_question_id = null;
      this.event_survey_number_errors = {};
    },
    open_event_survey_answers() {
      this.show_event_survey_answers = true;
      this.show_event_survey_form = false;
    },
    close_event_survey_answers() {
      this.show_event_survey_answers = false;
    },
    set_event_survey_answer(questionId, value) {
      Reflect.set(this.event_survey_answers, questionId, value);
      this.clear_event_survey_error(questionId);
    },
    clear_event_survey_error(questionId) {
      this.event_survey_errors = this.event_survey_errors.filter(
        (error) => String(error.id) !== String(questionId)
      );
      if (String(this.event_survey_first_error_question_id) === String(questionId)) {
        this.event_survey_first_error_question_id = null;
      }
    },
    has_event_survey_error(questionId) {
      return this.event_survey_errors.some((error) => String(error.id) === String(questionId));
    },
    get_event_survey_error(questionId) {
      return this.event_survey_errors.find((error) => String(error.id) === String(questionId))?.message || "";
    },
    get_event_survey_question_type_label(questionType) {
      const labels = {
        yes_no: "Yes / No",
        multiple_choice: "Single choice",
        selection: "Dropdown",
        checkbox: "Multi select",
        text: "Written response",
        paragraph: "Long response",
        text_area: "Long response",
        number: "Number",
        date: "Date",
        link: "Link",
      };

      return Reflect.has(labels, questionType)
        ? Reflect.get(labels, questionType)
        : "Question";
    },
    get_event_survey_display_answers(question) {
      const answers = Array.isArray(question?.answers) ? question.answers : [];
      return answers
        .map((item) => String(item?.answer || "").trim())
        .filter(Boolean)
        .flatMap((answer) => answer.split(",").map((value) => value.trim()).filter(Boolean));
    },
    toggle_creator_survey_details(survey) {
      const surveyId = survey?.id;
      if (!surveyId) return;
      this.expanded_creator_survey_id = this.expanded_creator_survey_id === surveyId ? null : surveyId;
    },
    is_creator_survey_expanded(survey) {
      return this.expanded_creator_survey_id === survey?.id;
    },
    get_creator_survey_response_count(survey) {
      const questions = Array.isArray(survey?.survey_questions) ? survey.survey_questions : [];
      const ids = new Set();
      questions.forEach((item) => {
        const answers = Array.isArray(item?.answers) ? item.answers : [];
        answers.forEach((answer) => {
          const userId = answer?.user?.id;
          if (userId !== undefined && userId !== null) {
            ids.add(String(userId));
          }
        });
      });
      return ids.size;
    },
    get_creator_survey_question_response_count(question) {
      return Array.isArray(question?.answers) ? question.answers.length : 0;
    },
    handle_realtime_event(event) {
      handle_manage_event_realtime(this, event);
    },
    get_auth_token() {
      return get_token();
    },
    // We need a local get_token for the helper functions that use this.get_token()
    get_token() {
      return get_token();
    },
    get_user_id() {
      return get_user_id();
    },
    format_date(dateString) {
      return format_date(dateString);
    },
    form_time(timeString) {
      return format_time(timeString);
    },
    check_description(description) {
      return check_description(description);
    },
    truncate_description(description, maxLength = 25) {
      return truncate_description(description, maxLength);
    },
    is_promo_valid(startDateStr, endDateStr) {
      return is_promo_valid(startDateStr, endDateStr);
    },
    open_promo_code_modal() {
      $("#availablePromosModal").modal("show");
    },
    has_agenda(event) {
      if (event?.agenda?.length) return true;
      return (event?.event_files || []).some((file) => {
        const name = String(file?.event_file_type?.name || "").toLowerCase();
        return name === "agenda" || name.includes("agenda");
      });
    },
    view_agenda(event) {
      this.$refs.eventAgendaRef?.open_view_agenda?.(event);
    },
    select_promo(promo) {
      select_promo(promo, () => {
        this.show_toast("Promo Code copied to clipboard!");
      });
    },
    show_toast(message) {
      show_toast(message);
    },
    toggle_description() {
      this.show_full_description = !this.show_full_description;
    },
    toggle_item(item_id) {
      this.selected_item_id = toggle_item(this.selected_item_id, item_id);
    },
    select_ticket(ticket) {
      const selectedTicketId = select_ticket(ticket);
      if (selectedTicketId === null || selectedTicketId === undefined) return;
      this.selected_ticket_id = selectedTicketId;
    },
    increment_ticket(ticket) {
      const nextQuantity = increment_ticket(ticket);
      if (nextQuantity === null) return;
      ticket.quantitySelected = nextQuantity;
    },
    decrement_ticket(ticket) {
      const nextQuantity = decrement_ticket(ticket);
      if (nextQuantity === null) return;
      ticket.quantitySelected = nextQuantity;
    },
    validate_ticket_date(ticket_start_date) {
      return validate_ticket_date(ticket_start_date);
    },
    calculate_subtotal() {
      return calculate_subtotal(this.event_tickets);
    },
    calculate_total() {
      return calculate_total(this.event_tickets, this.applied_promo);
    },
    add_rsvp() {
      add_rsvp(this);
    },
    handle_rsvp(event) {
      if (!this.token_exists) {
        window.location = '/sign_in_Finale';
        return;
      }
      if (!event) return;
      this.selected_event = event;

      if (event.is_free) {
        this.fetchEvents_extras(event.id);
      } else {
        this.reset_promo();
        const tickets = Array.isArray(event.event_tickets) ? event.event_tickets : [];
        this.event_tickets = tickets.map((ticket) => ({
          ...ticket,
          quantitySelected: 0,
        }));
        $("#ticket_modal").modal("show");
      }
    },
    rsvp_button(event) {
      return this.can_show_rsvp_button(event);
    },
    can_show_rsvp_button(event) {
      if (!event?.is_free) return false;
      // Use the same derived capacity/registration numbers as the "spots left" UI,
      // so realtime updates don't leave the button in a stale state.
      const capacity = capacity_value(event);
      if (!capacity) return true;
      const total = total_registrations(event);
      return total < capacity;
    },
    process_to_checkout() {
      if (!this.token_exists) {
        window.location = "/sign_in_Finale";
        return;
      }
      const selectedTickets = this.event_tickets
        .filter((t) => t.quantitySelected > 0)
        .map((t) => ({
          ticket_id: t.id,
          quantity: t.quantitySelected,
        }));
      if (selectedTickets.length === 0) {
        Swal.fire({
          title: "No tickets selected",
          text: "Please choose at least one ticket.",
          icon: "warning",
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }
      const request_data = {
        event_id: this.selected_event.id,
        user_id: this.user_details.user_id,
        tickets: selectedTickets,
        event_promo_code_id: this.applied_promo ? this.applied_promo.id : null,
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/ticket_purchase_api/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.get_auth_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(request_data),
        success: (response) => {
          if (response.status === "success") {
            const orderData = response.data;
            $("#ticket_modal").modal("hide");
            $(".modal-backdrop").remove();
            this.$router.push({ name: "checkout", params: { order_id: orderData.id } });
          }
        },
        error: () => {
          Swal.fire({
            title: "Error",
            text: "Failed to create order.",
            icon: "error",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        },
      });
    },
    fetchEvents_extras(event_id) {
      return fetchEvents_extras(this, event_id);
    },
    reset_promo() {
      this.promo_input = "";
      this.promo_message = "";
      this.promo_status = "";
      this.applied_promo = null;
    },
    apply_promo() {
      return apply_promo(this);
    },
    start_scanning(eventId) {
      start_scanning(this, eventId);
    },
    start_camera() {
      start_camera(this);
    },
    scan_loop(video, canvas, context) {
      scan_loop(this, video, canvas, context);
    },
    stop_scanning() {
      stop_scanning(this);
    },
    stop_camera_only() {
      stop_camera_only(this);
    },
    restart_scan() {
      restart_scan(this);
    },
    validate_ticket(scannedCode) {
      validate_ticket(this, scannedCode);
    },
    validate_rsvp(scannedCode) {
      validate_rsvp(this, scannedCode);
    },
    submit_registration() {
      submit_registration(this);
    },
    export_to_csv(event) {
      export_to_csv(event, this.cbo_domain);
    },
    cancel_rsvp(event_id, user_id = null) {
      cancel_rsvp(this, event_id, user_id);
    },
    view_ticket_attendees(event) {
      view_ticket_attendees(this, event);
    },
    new_format_date(dateString) {
      return new_format_date(dateString);
    },
    get_event_media_files(event) {
      return get_event_media_files(event);
    },
    get_event_media_type(item) {
      return get_event_media_type(item);
    },
    get_event_resource_files(event) {
      return get_event_resource_files(event);
    },
    open_media_gallery(event) {
      if (!this.gallery_access_allowed) {
        this.show_toast("Only attendees can view this gallery.");
        return;
      }
      open_media_gallery(this, event);
    },
    open_document_upload(event) {
      if (!this.materials_access_allowed) {
        this.show_toast("Only attendees can view these materials.");
        return;
      }
      open_document_upload(this, event);
    },
    get_icon_class(item) {
      return get_icon_class(this, item);
    },
    get_file_type_label(item) {
      return get_file_type_label(this, item);
    },
    get_file_name(item) {
      return get_file_name(this, item);
    },
    open_preview(item) {
      open_preview(this, item);
    },
    download_document(item) {
      download_document(this, item);
    },
    update_parent_event_files(newFiles) {
      update_parent_event_files(this, newFiles);
    },
    handle_parent_file_deletion(deletedFileId) {
      handle_parent_file_deletion(this, deletedFileId);
    },
    handle_pin_update(payload) {
      handle_pin_update(this, payload);
    },
    get_speaker_initials(speaker) {
      return get_speaker_initials(speaker);
    },
    get_sponsor_initials(sponsor) {
      return get_sponsor_initials(sponsor);
    },
    get_sponsor_logo(sponsor) {
      return get_sponsor_logo(sponsor);
    },
    scroll_sponsors(direction) {
      scroll_sponsors(this, direction);
    },
    update_sponsor_scroll_controls() {
      update_sponsor_scroll_controls(this);
    },
    format_sponsor_url(url) {
      return format_sponsor_url(url);
    },
    open_event_speakers(event) {
      if (!event) return;
      this.$refs.eventSpeakerRef?.open_view_speakers(event);
    },
    open_add_speakers(event) {
      if (!event) return;
      this.$refs.eventSpeakerRef?.open_add_speakers(event);
    },
    open_add_sponsors(event) {
      if (!event) return;
      this.$refs.eventSponsorRef?.open_add_sponsors(event);
    },
    open_view_sponsors(event) {
      if (!event) return;
      this.$refs.eventSponsorRef?.open_view_sponsors(event);
    },
    open_promo_code_manager(event) {
      if (!event) return;
      this.$refs.promoCodeRef?.open_promo_code_manager_modal?.(event);
    },
    open_agenda_create(event) {
      if (!event) return;
      this.$refs.eventAgendaRef?.open_create_agenda?.(event);
    },
    open_create_survey(event){
      if (!event) return;
      this.$refs?.eventSurveyRef?.open_create_survey(event);
    },
    open_view_survey(survey) {
      this.$refs?.eventSurveyRef?.open_view_survey(survey);
    },
    open_edit_survey(survey){
      this.$refs?.eventSurveyRef?.open_edit_survey(survey);
    },
    delete_survey(survey_id){
     this.$refs?.eventSurveyRef?.delete_survey(survey_id);
   },
    fetch_event() {
      fetch_event(this);
    },
    view_attendees() {
      view_attendees(this);
    },
    back() {
      this.$router.back();
    },
    toggle_event_survey_checkbox_answer(question_id, option, isChecked) {
      if (!this.event_survey_answers || typeof this.event_survey_answers !== "object") {
        this.event_survey_answers = {};
      }

      const q_id = String(question_id);
      let current_answers = Reflect.get(this.event_survey_answers, q_id);
      if (!Array.isArray(current_answers)) {
        current_answers = [];
      }

      let updated_answers = [...current_answers];
      if (isChecked) {
        if (!updated_answers.includes(option)) {
          updated_answers.push(option);
        }
      } else {
        updated_answers = updated_answers.filter((answer) => answer !== option);
      }

      Reflect.set(this.event_survey_answers, q_id, updated_answers);
      if (updated_answers.length > 0) {
        this.clear_event_survey_error(question_id);
      }
    },
    validate_event_survey_number(question_id) {
      const value = Reflect.get(this.event_survey_answers, question_id);
      if (value === "" || value === null || value === undefined) {
        Reflect.set(this.event_survey_number_errors, question_id, null);
        return;
      }
      if (isNaN(value)) {
        Reflect.set(this.event_survey_number_errors, question_id, "Please enter a valid number.");
      } else {
        Reflect.set(this.event_survey_number_errors, question_id, null);
        this.clear_event_survey_error(question_id);
      }
    },
  },
  mounted() {
    this.user_details = get_user_details();
    this.token_exists = !!get_token();
    if (client_domain.includes("cbo")) {
      this.cbo_domain = true;
    }
    if (client_domain.includes("workbook")) {
      this.workbook_domain = true;
    }
    this.fetch_event();

    this._realtime_event_handler = (evt) => this.handle_realtime_event(evt);
    window.addEventListener("realtime:event", this._realtime_event_handler);
  },
  beforeUnmount() {
    if (this._realtime_event_handler) {
      window.removeEventListener("realtime:event", this._realtime_event_handler);
      this._realtime_event_handler = null;
    }
  },
  watch: {
    "$route.params.event_id"() {
      this.fetch_event();
    },
    event: {
      handler() {
        this.$nextTick(() => {
          this.update_sponsor_scroll_controls();
        });
      },
      deep: true
    }
  }
};
